module.exports = __webpack_public_path__ + "media/application/images/ui/success-tick-a27717c8c43bb7d7f157891c86db952b.png";